import type { MouseEvent } from "react";

import type { IPlainTooltipProps } from "@similarweb/ui-components";
import { Tooltip } from "@similarweb/ui-components";

import { StyledIcon } from "./styles";

type Props = {
    tooltipContent: IPlainTooltipProps["tooltipContent"];
    href: string;
    onClick?: VoidFunction;
};

const LinkOut = ({ tooltipContent, href, onClick }: Props) => {
    const handleClick = (e: MouseEvent): void => {
        e.stopPropagation();
        onClick?.();
    };

    return (
        <div className="link-out-container">
            <Tooltip content={tooltipContent}>
                <a
                    href={href}
                    target="_blank"
                    rel="noreferrer"
                    onClick={handleClick}
                >
                    <StyledIcon
                        iconName="link-out"
                        size="xs"
                    />
                </a>
            </Tooltip>
        </div>
    );
};

export default LinkOut;
